export default "__VITE_ASSET__D0mtBku3__"